<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded">For mothers and daughters everywhere:</p>
<p class="ded">Through ups and downs,</p>
<p class="ded">through laughter and tears,</p>
<p class="ded">the bond that connects us remains</p>
<p class="ded-bot">forever strong.</p>
<p class="ded">For my own mother:</p>
<p class="ded">Your love has made me a better person.</p>
<p class="ded-bot">Thanks for being my biggest supporter!</p>
<p class="ded">And finally, for my precious baby girl:</p>
<p class="ded">Every day I watch you grow,</p>
<p class="ded">I am amazed at the wonder of life.</p>
<p class="ded">And when you smile at me—</p>
<p class="ded">Ah!</p>
<p class="ded">It doesn’t get better than that.</p>
<p class="ded">I hope to enrich your life</p>
<p class="ded">the way my mother did mine.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?5af4ffa8